import React, { useState, useRef, useEffect } from "react";
import styles from "./text.module.css";
import { TextField, Autocomplete } from "@mui/material";
import ElementTitle from "ui/crfs/element_title";
import DividerLine from "ui/crfs/divider_line";
import CheckIcon from "@mui/icons-material/Check";
import DataCompleteChangeModal from "ui/crfs/data_complete_change_modal";
import ElementMenu from "ui/crfs/element_menu";

export default function Text(props) {
  const {
    key,
    field,
    field_id,
    title,
    onUpdate,
    enableQuery,
    length,
    placeHolder,
    show_checkmark,
    read_only,
    crfStatus,
    multi_entry_crf_id,
    crf_id,
    toggleHistory,
    selected_audit_icon,
    setQueryModalData,
    captureCompleteDateChangeReason = false,
  } = props;

  const [valueObj, setValueObj] = useState({});

  useEffect(() => {
    setValueObj(field.value_obj);
  }, [crf_id, multi_entry_crf_id, field]);

  const [showingCompleteChangeModal, setShowingCompleteChangeModal] = useState(false);
  const ref = useRef(null);

  const setValue = (newValue) => {
    let obj = { ...valueObj };
    obj.value = newValue;
    setValueObj(obj);
  };

  const updateValue = (newValue) => {
    if (crfStatus === "data_complete" && captureCompleteDateChangeReason) {
      setShowingCompleteChangeModal(true);
      return;
    }
    let obj = { ...valueObj };
    obj.value = newValue;
    obj.value_name = field.value_name;
    setValueObj(obj);
    onUpdate(obj);
  };

  const onKeyDown = (key) => {
    if (key.keyCode === 13) {
      ref.current.blur();
    }
  };

  const onBlur = () => {
    updateValue(valueObj.value);
  };

  const closeModal = () => {
    setValue(field.value_obj.value);
    setShowingCompleteChangeModal(false);
  };
  const acceptTempStorage = (reason) => {
    onUpdate({ ...valueObj, reason });
    setShowingCompleteChangeModal(false);
  };

  return (
    <div className={styles.outer_wrapper}>
      <div className={styles.input_flex}>
        <div className={styles.left_split}>
          <div>
            <ElementTitle required={field.required} title={title} />
          </div>
        </div>

        <div className={styles["right-split"]}>
          {read_only || field.read_only ? (
            <React.Fragment>
              <div>{valueObj.value || "---"}</div>
              <div className={styles.audit_icon}>
                <ElementMenu {...props} />
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {field.suggestions_enabled ? (
                <Autocomplete
                  inputRef={ref}
                  value={valueObj.value || ""}
                  options={field.suggestions.split(",") || []}
                  freeSolo
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "5px",
                      paddingLeft: "10px",
                      textAlign: "left",
                    },
                  }}
                  fullWidth
                  // blurOnSelect
                  onChange={(e, newValue) => {
                    updateValue(newValue);
                    setTimeout(() => ref.current.blur(), 100);
                  }}
                  onBlur={(e, s) => {
                    updateValue(e.target.value);
                  }}
                  // onInputChange={(e) => console.log("onInputChange", e?.target?.value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      inputRef={ref}
                      placeholder={placeHolder || ""}
                      // value={valueObj.value || ""}
                      autoComplete="off"
                      // onKeyDown={onKeyDown}
                      onBlur={() => {}}
                      fullWidth
                      multiline={field.multiline}
                    />
                  )}
                  slotProps={{ listbox: { style: { maxHeight: "480px" } } }}
                />
              ) : (
                <TextField
                  inputRef={ref}
                  placeholder=""
                  value={valueObj.value || ""}
                  onChange={(e) => setValue(e.target.value)}
                  autoComplete="off"
                  onKeyDown={onKeyDown}
                  onBlur={onBlur}
                  sx={{
                    "& .MuiInputBase-input": {
                      padding: "5px",
                      paddingLeft: "10px",
                      textAlign: "left",
                    },
                  }}
                  fullWidth
                  multiline={field.multiline}
                />
              )}
              {field.value_obj?.missing ? <div className={styles.missing}>missing</div> : null}
              <div className={styles.audit_icon}>
                <ElementMenu {...props} />
              </div>
            </React.Fragment>
          )}

          {show_checkmark ? (
            <div className={styles.check_mark}>
              <CheckIcon sx={{ color: "green" }} />
            </div>
          ) : null}
        </div>
      </div>

      <DividerLine />
      <DataCompleteChangeModal isOpen={showingCompleteChangeModal} close={closeModal} onYes={acceptTempStorage} />
    </div>
  );
}
